import { Dispatch, SetStateAction, createContext } from 'react';

export interface AudioPlayerData {
  userId: string;
  channelId: number;
  storyId: number;
  cardId: number;
  cardTitle: string;
  src: string;
  isPlaying: boolean;
  chatId?: number;
  blockId?: string;
}

export interface AudioPlayerContextProps {
  audioPlayerData: AudioPlayerData;
  setAudioPlayerData: Dispatch<SetStateAction<AudioPlayerData>>;
}

export const AudioPlayerContext = createContext<AudioPlayerContextProps>(
  {} as AudioPlayerContextProps
);
